<zimmerer-route-ion-wrapper class="ion-page">
  <image-slider [fxHide]="!hasSliderImages" [page]="'news'" [hasImageSliderBar]="false" fxHide.gt-md></image-slider>

  <div class="threecol withImageSliderBar" fxLayout="column" fxLayoutAlign.gt-md="center center">
    <div
      class="main-col"
      [class.withTopPadding]="mobileService.isMobile"
      [class.noSlider]="!hasSliderImages"
      fxLayout="column"
    >
      <image-slider [fxHide]="!hasSliderImages" [page]="'news'" [hasImageSliderBar]="false" fxHide.lt-lg></image-slider>

      <div fxHide.gt-md>
        <create-panel></create-panel>
      </div>

      <!-- blog -->
      <div class="section">
        <headline [headlineText]="'Blog:'" [headlineDescription]="'News, Beiträge, Tipps'"></headline>

        <div class="grid">
          <blog-card
            *ngFor="let blog of news?.blog"
            [entity]="blog"
            #impressionAnchor
            data-entitytype="Blog"
            data-id="{{ blog.id }}"
          >
          </blog-card>
        </div>

        <go-to-link (click)="StateService.goto('/blog')" [goToLinkText]="'Zum Blog'"></go-to-link>
      </div>
    </div>

    <div class="newsfeed-top-banner-container">
      <newsfeed-top-banner></newsfeed-top-banner>
    </div>

    <div
      class="main-col"
      [class.withTopPadding]="mobileService.isMobile"
      [class.noSlider]="!hasSliderImages"
      fxLayout="column"
    >
      <!-- advert -->
      <div class="section">
        <headline
          [headlineText]="'Marktplatz:'"
          *ngIf="mobileService.isMobile"
          [headlineDescription]="'Kaufen & verkaufen'"
        ></headline>

        <headline
          [headlineText]="'Marktplatz:'"
          *ngIf="!mobileService.isMobile"
          [headlineDescription]="'Zimmereibedarf kaufen und verkaufen'"
        ></headline>

        <div class="grid">
          <advert-grid-item
            *ngFor="let advert of news?.advert"
            [entity]="advert"
            #impressionAnchor
            data-entitytype="Advert"
            data-id="{{ advert.id }}"
          >
          </advert-grid-item>
        </div>

        <go-to-link (click)="StateService.goto('/market')" [goToLinkText]="'Zum Marktplatz'"></go-to-link>
      </div>

      <!-- job -->
      <div class="section">
        <headline
          [headlineText]="'Jobbörse:'"
          *ngIf="mobileService.isMobile"
          [headlineDescription]="'Anzeigen & Gesuche'"
        ></headline>

        <headline
          [headlineText]="'Jobbörse:'"
          *ngIf="!mobileService.isMobile"
          [headlineDescription]="'Stellenanzeigen und Stellengesuche'"
        ></headline>

        <div class="grid">
          <job-card
            *ngFor="let job of news?.job"
            [entity]="job"
            #impressionAnchor
            data-entitytype="Job"
            data-id="{{ job.id }}"
          >
          </job-card>
        </div>

        <go-to-link (click)="StateService.goto('/job')" [goToLinkText]="'Zur Jobbörse'"></go-to-link>
      </div>
    </div>

    <div class="newsfeed-bottom-banner-container">
      <newsfeed-bottom-banner></newsfeed-bottom-banner>
    </div>

    <div
      class="main-col"
      [class.withTopPadding]="mobileService.isMobile"
      [class.noSlider]="!hasSliderImages"
      fxLayout="column"
    >
      <!-- video -->
      <div class="section">
        <headline [headlineText]="'Videos:'" [headlineDescription]="'Rund um´s Handwerk'"> </headline>

        <div class="grid">
          <blog-card
            *ngFor="let video of news?.video"
            [entity]="video"
            #impressionAnchor
            data-entitytype="Blog"
            data-id="{{ video.id }}"
          >
          </blog-card>
        </div>

        <go-to-link
          (click)="StateService.goto('/blog?blog_category_id=' + CategoriesService.videocat.id)"
          [goToLinkText]="'Zu den Video-Beiträgen'"
        ></go-to-link>
      </div>

      <div class="section">
        <headline
          [headlineText]="'Unsere Partner:'"
          [headlineDescription]="'Hersteller, Lieferanten und Dienstleister der Branche'"
        ></headline>
        <partner-slider></partner-slider>

        <go-to-link (click)="StateService.goto('/partners')" [goToLinkText]="'Alle Partner ansehen'"></go-to-link>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</zimmerer-route-ion-wrapper>
